import React from 'react';
import { InstagramIcon, FacebookIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-dark text-gray-300 pt-16 pb-8 px-6" data-id="element-43">
      <div className="container mx-auto max-w-7xl" data-id="element-44">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12 text-center md:text-left" data-id="element-45">
          {/* Column 1: Brand & Quick Links */}
          <div className="flex flex-col items-center md:items-start" data-id="element-46">
            <img src="https://cdn.magicpatterns.com/uploads/uVzrfAneKFyMB5qb1N8DUF/hanse-new-logo_redline_pool_tile.png" alt="Redline Pool Tile Restoration" className="w-20 h-20 mb-6 bg-white rounded-full p-1 opacity-90 hover:opacity-100 transition-opacity" data-id="element-47" />
            <h4 className="text-white font-bold uppercase tracking-wider mb-4" data-id="element-48">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-49">
              <li data-id="element-50">
                <a href="#hero" className="hover:text-brand-red transition-colors" data-id="element-51">
                  Home
                </a>
              </li>
              <li data-id="element-52">
                <a href="#about" className="hover:text-brand-red transition-colors" data-id="element-53">
                  About Us
                </a>
              </li>
              <li data-id="element-54">
                <a href="#services" className="hover:text-brand-red transition-colors" data-id="element-55">
                  Services
                </a>
              </li>
              <li data-id="element-56">
                <a href="#gallery" className="hover:text-brand-red transition-colors" data-id="element-57">
                  Gallery
                </a>
              </li>
              <li data-id="element-58">
                <a href="#service-area" className="hover:text-brand-red transition-colors" data-id="element-59">
                  Service Area
                </a>
              </li>
              <li data-id="element-60">
                <a href="#contact" className="hover:text-brand-red transition-colors" data-id="element-61">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Column 2: Services */}
          <div className="flex flex-col items-center md:items-start" data-id="element-62">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-63">
              Our Services
            </h4>
            <ul className="space-y-3" data-id="element-64">
              <li data-id="element-65">
                <a href="#services" className="hover:text-brand-red transition-colors" data-id="element-66">
                  Pool Tile Cleaning
                </a>
              </li>
              <li data-id="element-67">
                <a href="#services" className="hover:text-brand-red transition-colors" data-id="element-68">
                  Acid Wash
                </a>
              </li>
              <li data-id="element-69">
                <a href="#services" className="hover:text-brand-red transition-colors" data-id="element-70">
                  Chlorine Wash
                </a>
              </li>
              <li data-id="element-71">
                <a href="#services" className="hover:text-brand-red transition-colors" data-id="element-72">
                  Green to Clean
                </a>
              </li>
              <li data-id="element-73">
                <a href="#services" className="hover:text-brand-red transition-colors" data-id="element-74">
                  Weekly Maintenance
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Contact */}
          <div className="flex flex-col items-center md:items-start" data-id="element-75">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-76">
              Contact
            </h4>
            <ul className="space-y-4" data-id="element-77">
              <li data-id="element-78">
                <a href="mailto:redlinepooltile@gmail.com" className="flex items-center gap-3 hover:text-brand-red transition-colors" data-id="element-79">
                  <MailIcon className="w-5 h-5 text-brand-red" data-id="element-80" />
                  redlinepooltile@gmail.com
                </a>
              </li>
              <li data-id="element-81">
                <a href="tel:4802583707" className="flex items-center gap-3 hover:text-brand-red transition-colors" data-id="element-82">
                  <PhoneIcon className="w-5 h-5 text-brand-red" data-id="element-83" />
                  (480) 258-3707
                </a>
              </li>
              <li className="flex items-center gap-3 justify-center md:justify-start text-center md:text-left" data-id="element-84">
                <MapPinIcon className="w-5 h-5 text-brand-red" data-id="element-85" />
                Greater Phoenix Area, Arizona
              </li>
            </ul>

            <div className="flex gap-4 mt-8" data-id="element-86">
              <a href="#" className="bg-white/10 p-3 rounded-full hover:bg-brand-red hover:text-white transition-colors" aria-label="Instagram" data-id="element-87">
                <InstagramIcon className="w-5 h-5" data-id="element-88" />
              </a>
              <a href="#" className="bg-white/10 p-3 rounded-full hover:bg-brand-red hover:text-white transition-colors" aria-label="Facebook" data-id="element-89">
                <FacebookIcon className="w-5 h-5" data-id="element-90" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400" data-id="element-91">
          <p data-id="element-92">© 2025 Redline Pool Tile Restoration. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-93">
            <a href="#" className="hover:text-white transition-colors" data-id="element-94">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-95">
              Terms & Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>;
}